import { render, staticRenderFns } from "./postModal.vue?vue&type=template&id=828e610e&scoped=true&"
import script from "./postModal.vue?vue&type=script&lang=js&"
export * from "./postModal.vue?vue&type=script&lang=js&"
import style0 from "./postModal.vue?vue&type=style&index=0&id=828e610e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828e610e",
  null
  
)

export default component.exports